var BeginCheckoutPixel = (function(GlobalSettings)
{
    var BeginCheckoutPixel = function(){};

    _.extend(BeginCheckoutPixel.prototype, {
        trigger: function(data)
        {
            if (!Pixel || !Pixel.events || !data) {
                return;
            }

            var items = (data.Items || []).map(function(item){
                return _.extend(item, {
                    Currency: GlobalSettings.Currency
                });
            });
            Pixel.events.trigger('viewCheckout', items);
        }
    });
    return BeginCheckoutPixel;
    
})(GlobalSettings);

var RemoveFromCartPixel = (function()
{
    var RemoveFromCartPixel = function(){};

    _.extend(RemoveFromCartPixel.prototype, {
        trigger: function(data)
        {
            if (!Pixel || !Pixel.events) {
                return;
            }
            Pixel.events.trigger('removeFromCart', data);
        }
    });

    return RemoveFromCartPixel;
})();


var AddPaymentInfoPixel = (function(GlobalSettings)
{
    var AddPaymentInfoPixel = function(){};

    _.extend(AddPaymentInfoPixel.prototype, {
        trigger: function(order, currentMethod)
        {
            if(!Pixel || !Pixel.events){
                return;
            }

            var items = order.get('ItemList');
            var summary = order.get('Summary');

            if(!items) return;

            var data = { 
                Items: items.toJSON(), 
                PaymentType: currentMethod.get('PaymentType'),
                Currency: GlobalSettings.Currency,
                Total: summary.get('Total'),
            };

            Pixel.events.trigger('paymentInfo', data);
        }
    });

    return AddPaymentInfoPixel;
})(GlobalSettings);


var ShippingInfoPixel = (function(GlobalSettings)
{
    var ShippingInfoPixel = function(){}

    _.extend(ShippingInfoPixel.prototype, {
        trigger: function(data){
            if(!Pixel || !Pixel.events || !data){
                return;
            }

            Pixel.events.trigger('addShippingInfo', {
                Items: data.Items, 
                Total: data.Summary.Total,
                Currency: GlobalSettings.Currency
            });
        }
    });

    return ShippingInfoPixel;
})(GlobalSettings);